import type { UseQueryOptions } from 'react-query';

import {
  cateringLeadsApiKeys,
  useCateringLeadsApi,
} from '../../../../hooks/api/catering-leads/useCateringLeadsApi';
import { useGetApi } from '../../../../hooks/api/useGetApi';
import type { CateringLeadTicket } from '../../../../types/events/catering-leads';

export function useCateringLeadsStatus(
  organizationId: string,
  options?: UseQueryOptions<CateringLeadTicket>
) {
  const api = useCateringLeadsApi();

  return useGetApi({
    enabled: !!organizationId,
    queryKey: cateringLeadsApiKeys.isRunningTicket(organizationId),
    request: () => api.isRunningTicket(organizationId),
    ...options,
  });
}
